export enum CumulRole {
  OWNER = "owner",
  VIEWER = "viewer",
  DESIGNER = "designer",
}
